import React from 'react';
import { Notification } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  success: {
    backgroundColor: '#4caf50 !important',
    color: 'white !important',
    '& .MuiSnackbarContent-message': {
      color: 'white',
    },
  },
  error: {
    backgroundColor: '#f44336 !important',
    color: 'white !important',
    '& .MuiSnackbarContent-message': {
      color: 'white',
    },
  },
  warning: {
    backgroundColor: '#ff9800 !important',
    color: 'white !important',
    '& .MuiSnackbarContent-message': {
      color: 'white',
    },
  },
});

const CustomNotification = (props) => {
  const classes = useStyles();

  return (
    <Notification
      {...props}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={4000}
      classes={{
        success: classes.success,
        error: classes.error,
        warning: classes.warning,
      }}
    />
  );
};

export default CustomNotification;
